module.exports = __webpack_public_path__ + "img/media-presence-1.254732f7.png";